import type { ReactNode } from "react";
import { Box, Image, chakra } from "@chakra-ui/react";

const ChakraBlockquote = chakra("blockquote");

export const Blockquote = ({ children }: { children: ReactNode }) => (
  <ChakraBlockquote
    p={6}
    my={6}
    borderRadius="md"
    bgColor="neutral.100"
    backgroundImage="url(https://img.airhelp.com/components/quotes.svg)"
    backgroundRepeat="no-repeat"
    backgroundPosition="right 60px bottom"
  >
    <Image boxSize={8} mb={4} src="https://img.airhelp.com/components/quotes-in-a-green-circle.svg" />
    <Box fontSize="lg">{children}</Box>
  </ChakraBlockquote>
);
